import React from 'react';

import { SVGProps } from './type';

function Icon(props: SVGProps) {
  const { size = 24, color = '#000', ...rest } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      {...rest}
    >
      <path
        fill={color}
        fillRule="evenodd"
        d="M10.844 3.5a5.25 5.25 0 100 10.5 5.25 5.25 0 000-10.5zm-6.75 5.25a6.75 6.75 0 1113.5 0 6.75 6.75 0 01-13.5 0z"
        clipRule="evenodd"
      />
      <path
        fill={color}
        fillRule="evenodd"
        d="M10.844 15.499A9.75 9.75 0 002.4 20.375a.75.75 0 01-1.3-.75 11.25 11.25 0 0112.727-5.223.75.75 0 11-.398 1.446 9.749 9.749 0 00-2.585-.349zM19.844 11.75a.75.75 0 01.75.75V14a.75.75 0 01-1.5 0v-1.5a.75.75 0 01.75-.75zM19.844 20a.75.75 0 01.75.75v1.5a.75.75 0 01-1.5 0v-1.5a.75.75 0 01.75-.75z"
        clipRule="evenodd"
      />
      <path
        fill={color}
        fillRule="evenodd"
        d="M18.485 14.75a.868.868 0 00-.623.267.962.962 0 00-.268.67c0 .256.099.497.268.67a.868.868 0 00.623.268h1.968c.641 0 1.252.262 1.698.721.446.46.693 1.077.693 1.716 0 .64-.247 1.258-.693 1.717a2.368 2.368 0 01-1.698.721H17.5a.75.75 0 010-1.5h2.953c.23 0 .454-.093.623-.267a.962.962 0 00.268-.67.962.962 0 00-.268-.67.868.868 0 00-.623-.268h-1.968a2.368 2.368 0 01-1.698-.721 2.462 2.462 0 01-.693-1.716c0-.64.247-1.258.693-1.717a2.368 2.368 0 011.698-.721h2.953a.75.75 0 010 1.5h-2.953z"
        clipRule="evenodd"
      />
    </svg>
  );
}

export default Icon;
